import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { loadSales } from 'Reduxes/pos/sales/salesActions'
import TableData from './TableData'
import FormSales from './FormSales'
import FormReturn from './FormReturn'
import Detail from './Detail'


function Sales() {

    const dispatch = useDispatch()
    const [content, setContent] = useState('table')
    const [idShow, setIdShow] = useState(null)

    const showDetail = (id) => {
        setIdShow(id);
        setContent('detail')
    }
    const showTable = () => {
        setContent('table');
    }
    const showForm = (type, id) => {
        setIdShow(id);
        setContent('form' + type);
    }
    const refreshTable = () => {
        dispatch(loadSales())
        showTable()
    }

    const renderContent = (contentType) => {
        switch (contentType) {
            case 'table':
                return (<TableData showForm={showForm} showDetail={showDetail} />)
            case 'formSalesNew':
                return (<FormSales type="new" showTable={refreshTable} />)
            case 'formSalesEdit':
                return (<FormSales type="edit" rowId={idShow} showTable={showTable} />)
            case 'formSalesReturnEdit': // ini untuk handle sales yang dari tombol return pada row
                return (<FormReturn type="addArrow" rowId={idShow} showTable={showTable} />)
            case 'formReturnNew':
                return (<FormReturn type="new" showTable={refreshTable} />)
            case 'formReturnEdit':
                return (<FormReturn type="edit" showTable={showTable} rowId={idShow} />)
            case 'detail':
                return (<Detail showForm={showForm} showTable={showTable} rowId={idShow} />)
            default:
                return <>Nothing to show here</>
        }
    }

    useEffect(() => {
        dispatch(loadSales());
    }, [])

    return (
        <>
            { renderContent(content)}
        </>
    )
}

export default Sales